import React from 'react';

const buildCards = (resumen, cursoSeleccionado) => {
  const cards = [
    { key: 'total', label: 'Total materias', value: resumen.total ?? 0, accent: 'primary', icon: 'bi-journal-text' },
    {
      key: 'horas',
      label: 'Horas totales',
      value: `${(resumen.horasTotales ?? 0).toFixed(1)}h`,
      accent: 'success',
      icon: 'bi-clock',
    },
  ];

  if (cursoSeleccionado) {
    cards.push({
      key: 'curso',
      label: 'Curso',
      value: cursoSeleccionado,
      accent: 'info',
      icon: 'bi-collection',
      valueClass: 'value-sm',
    });
  }

  return cards;
};

export default function MallaSummary({ resumen = {}, cursoSeleccionado }) {
  const cards = buildCards(resumen, cursoSeleccionado);

  return (
    <div className="management-card mb-4">
      <div className="malla-summary-grid">
        {cards.map((card) => {
          const accentClass = card.accent ? `accent-${card.accent}` : '';
          return (
            <div key={card.key} className="w-100">
              <div className={`management-stat-card malla-summary-card h-100 ${accentClass}`}>
                <div className="management-stat-icon">
                  <i className={`bi ${card.icon}`} />
                </div>
                <div>
                  <p className="management-stat-label mb-1">{card.label}</p>
                  <div
                    className={`management-stat-value ${card.valueClass || ''}`.trim()}
                    title={card.value}
                  >
                    {card.value}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
